import { render, staticRenderFns } from "./BookingNearestDriverSummary.vue?vue&type=template&id=04f17593&"
import script from "./BookingNearestDriverSummary.vue?vue&type=script&lang=js&"
export * from "./BookingNearestDriverSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports